import React, {Component} from 'react';
import Fab from "@material-ui/core/Fab";
import CircularProgress from "@material-ui/core/CircularProgress";
import {checkPaymentMethodStatus} from "../../../api/payment";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import CreditCard from '@material-ui/icons/CreditCard';
import Bank from '@material-ui/icons/AccountBalance';
import {PAYMENT_METHOD_CREDIT_CARD} from "./helpers";
import PropTypes from 'prop-types';

const styles = theme => ({
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  fabProgress: {
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  footer: {
    padding: '1rem',
    overflow: 'hidden',
  },
});

const PendingBody = () => <React.Fragment>
  You will be prompted with a membership contract upon completion. <br/>
  Please do not close this window.
</React.Fragment>;

class VerifyPaymentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: ''
    };
    this.paymentProcessingTimeout = 3 * 60 * 1000; // 3min
  }

  setFailureState = () => {
    this.setState({error: 'Payment verification failed.'});
  };

  componentDidMount() {
    let timeUsed = 0;
    const interval = 2000;
    const apiCall = () => {
      setTimeout(() => checkPaymentMethodStatus(this.props.sessionKey)
        .then(({data}) => {
          timeUsed += interval;
          if (data.success) return this.props.onSuccess(data);
          if ((!data.success && data.ready) || (timeUsed >= this.paymentProcessingTimeout)) {
            return this.setFailureState();
          }
          if (timeUsed < this.paymentProcessingTimeout) apiCall();
        })
        .catch(this.setFailureState),
        interval);
    };
    apiCall();
  }

  render() {
    const {classes, paymentMethod} = this.props;
    const Icon = paymentMethod === PAYMENT_METHOD_CREDIT_CARD ? CreditCard : Bank;
    return (
      <Dialog
        open
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {this.state.error || 'We are verifying your payment info.'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.state.error ?
              'Please try another method of payment, or call us at 1-844-768-6945 to complete your sign-up.' :
              <PendingBody/>
            }
          </DialogContentText>
        </DialogContent>
        {
          this.state.error ?
            <DialogActions>
              <Button variant="contained" color="primary"  onClick={this.props.handleClose}>Close</Button>
            </DialogActions> :
            <DialogActions className={classes.footer}>
              <div className={classes.wrapper}>
                <Fab color="secondary">
                  <Icon/>
                </Fab>
                <CircularProgress size={68} className={classes.fabProgress}/>
              </div>
            </DialogActions>
        }
      </Dialog>
    );
  }
}

VerifyPaymentModal.propTypes = {
  handleClose: PropTypes.func
};

export default withStyles(styles)(VerifyPaymentModal);
